'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    if (Object.keys(data).length === 0) return;
    var ul = document.createElement('ul');
    element.appendChild(ul);
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        if (Object.keys(data[key]).length > 0) createTree(li, data[key]);
        ul.appendChild(li);
    }
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.7b228104.js.map
